import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import theme from './config/theme';
import AccentState from './context/AccentState';
import BackgroundState from './context/BackgroundState';
import LoaderState from './context/LoaderState';
import RecruiterModeState from './context/RecruiterModeState';
import AppRoutes from './components/AppRoutes';
import Background from './components/Background';
import Navbar from './components/Navbar';
import CustomCursor from './components/CustomCursor';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <HelmetProvider>
            <ChakraProvider theme={theme}>
                <LoaderState>
                    <AccentState>
                        <BackgroundState>
                            <RecruiterModeState>
                                <CustomCursor />
                                <Background />
                                <BrowserRouter>
                                    <Navbar />
                                    <AppRoutes />
                                </BrowserRouter>
                            </RecruiterModeState>
                        </BackgroundState>
                    </AccentState>
                </LoaderState>
            </ChakraProvider>
        </HelmetProvider>
    </React.StrictMode>
);
